import {hel_net_is_logged_in} from '../logics/auth';
import {parseJwt} from '../logics/parseJwt';
import {hel_isLangJa} from '../logics/platform';
import {hel_toast_notify_message} from '../logics/shared';
import {hel_net_select_authorization_jwt} from '../logics/skyway';
import {GetIHeliNetwork} from '../singleton_registry';

import {CApiNotification} from './apiNotificationLib/CApiNotification';
import {onNetLobbyingUpdate} from './networkCallback';
import {preparePositionChannelSession} from './networkMediator';

import type {AuthorizationJwtDataListResult} from '../logics/skyway';
import type {ChannelSession} from '../types/network';

let alreadyAddedEventListeners = false;

/**
 * 非同期ロビイング機能を使用する座標チャンネルへの参加
 * @param args
 * @returns
 */
export const hel_net_join_position_channel_by_lobbying = async (args: {
  spatiumCode: string;
  worldCode: string;
}): Promise<{authorizationJwt: string | null}> => {
  if (!alreadyAddedEventListeners) {
    alreadyAddedEventListeners = true;

    CApiNotification.addEventListener('Personal', 'Lobby', async (data) => {
      // HeliScriptへ通知
      onNetLobbyingUpdate({
        queueId: data.QueueId,
        state: data.State,
        waitCount: data.WaitCount,
        jwt: data.JWT,
        errorCode: data.ErrorCode,
        message: data.Message
      });

      const isLangJa = hel_isLangJa();
      switch (data.State) {
        case 'waiting':
          hel_toast_notify_message(
            isLangJa ? `現在${data.WaitCount}人待ち中` : `現在${data.WaitCount}人待ち中` // TODO: 英語対応
          );
          break;

        case 'matched': {
          const heliNetwork = GetIHeliNetwork();
          if (!heliNetwork) {
            throw new Error('GetIHeliNetwork() returns null.');
          }
          const channelSession = parseJwt(data.JWT) as ChannelSession;
          await preparePositionChannelSession(channelSession.position_channel_code);
          await heliport.v3.api.channelSessionApi.setChannelSessionJwt({jwt: data.JWT});
          const positionChannelDetail = (
            await heliNetwork.getPosChannel(channelSession.position_channel_code)
          ).getPositionChannelDetail();
          if (!positionChannelDetail) {
            throw new Error(
              `CHeliNetwork.getPosChannel('${channelSession.position_channel_code}') failed.`
            );
          }
          await heliNetwork.initializeChannelSessionContext(positionChannelDetail.channel_id);
          await heliNetwork.applyPositionChannelSession(positionChannelDetail, data.JWT);
          break;
        }
        case 'timeout':
          break;
      }
    });
  }

  const authorizationJwt = hel_net_select_authorization_jwt({
    jwtDataList:
      (hel_net_is_logged_in()
        ? ((await heliport.v3.api.conferenceManagerApi.fetchHierarchicalAuthorizationJwts(
            args
          )) as AuthorizationJwtDataListResult)
        : null
      )?.data?.jwts ?? [],
    spatiumCode: args.spatiumCode,
    worldCode: args.worldCode
  });

  const result = await heliport.v3.api.channelSessionApi.enterPositionChannelByLobbying(
    Object.assign({authorizationJwt, ticketJwt: null}, args)
  );
  if (result.status !== 'ok') {
    throw new Error(
      `heliport.v3.api.channelSessionApi.enterPositionChannelByLobbying() returns\n${JSON.stringify(result, null, 2)}`
    );
  }

  return {authorizationJwt};
};
